"use client";

import type { HTMLAttributes, FC, Ref } from "react";
import { mergeClasses } from "@huub-web/utils";

import type { ClassNameProp } from "../../props";
import { inputList } from "./InputList.css";
import { Flex, type FlexProps } from "../Flex/Flex";

export type InputListProps = HTMLAttributes<HTMLDivElement> &
  ClassNameProp &
  Pick<FlexProps, "justify"> & { ref?: Ref<HTMLDivElement> };

/**
 * A card component that displays a title and a list of items.
 */
export const InputList: FC<InputListProps> = ({
  justify,
  className,
  children,
  ref,
  ...props
}) => (
  <Flex
    ref={ref}
    className={mergeClasses(inputList, className)}
    align="center"
    justify={justify}
    wrap
    {...props}
  >
    {children}
  </Flex>
);
